let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jmn8B")).then(() => parcelRequire('jrhuf'));